import useDialogsStore from '../stores/dialogs'
import ErrorView from './ErrorView'
import { ErrorBoundary } from 'react-error-boundary'

const DialogProvider = () => {
  const dialogs = useDialogsStore(state => state.dialogs)

  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <ErrorView isDialog error={error} resetErrorBoundary={resetErrorBoundary} />
      )}>
      {dialogs.map((dialog: any) => {
        const Component = dialog.component
        return <Component key={dialog.key} open={dialog.isOpen} {...dialog.props} />
      })}
    </ErrorBoundary>
  )
}

export default DialogProvider
